import { render, staticRenderFns } from "./SetTimeModal.vue?vue&type=template&id=487f8259&scoped=true&"
import script from "./SetTimeModal.vue?vue&type=script&lang=js&"
export * from "./SetTimeModal.vue?vue&type=script&lang=js&"
import style0 from "./SetTimeModal.vue?vue&type=style&index=0&id=487f8259&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f8259",
  null
  
)

export default component.exports